import React, {useEffect, useRef, useState} from 'react';

import {
  animated,
  useSpring,
} from 'react-spring';
import styled from 'styled-components';

import DropdownIcon from '../../../assets/images/icon/DropdownIcon';
import {isEmpty, textTransform} from "../../../util";

interface DropdownProps {
    items: any[];
    selected?: any;
    dropdownTitle?: any;
    onClick?: any;
    state?: string;
    altText?:string;
    index?:number
    height?:number
    borderColor?:string
    maxHeight?:number
}

const DropdownContainer = styled.div`
    position: relative;
    transition: max-height 0.1s;
    color: #333;
    &:hover{
        .dropdownBtn{
            border: solid 2px #333!important;   
        }
    }
    &.on{
        .dropdownBtn{
            border: solid 2px #333!important;
        }
    }
`;

const DropdownButton = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-family: Europa-Regular;
    font-size: 16px;
    outline: none;
    border-radius: 8px;
    border: solid 1px rgba(51, 51, 51, 0.3);
    padding: 12px 16px;
    display: flex;
    align-items: center;
    height: 48px;
    transition: all 0.2s;
 
    span{
        pointer-events: none;
        user-select: none;
    }
`;

const AnimatedDropdown = styled(animated.div)`
    position: absolute;
    overflow: hidden;
    width: 100%;
    z-index: 999999;
    background: #fff;
    border: solid 1px rgba(51, 51, 51, 0.3);
    border-radius: 8px;
    //margin-top: 8px;

    &.on {
        //border: solid 2px #333 !important;
    }

    box-shadow: 1px 3px 3px 2px rgba(51, 51, 51, 0.3);
`;
const DropdownList = styled.div.withConfig({
    shouldForwardProp: (prop) => !['isOpen'].includes(prop),
})<StyledComponentProps>`
    width: 100%;
    padding:0px 8px;
    background: #fff;
    max-height: ${(props) => (props.isOpen ? "200px" : "0")};
    overflow-y: auto;
    transition: max-height 0.1s;
    scrollbar-width: thin;
    scrollbar-color: #33333360 transparent!important;

    &::-webkit-scrollbar {
        width: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
`;
const DropdownItem = styled(animated.div)`
    transition: all 0.2s;
    &:nth-child(1) {
        border-top: solid 1px rgba(51, 51, 51, 0.3);
    }
    &:hover{
        background-color: #E5E5E5;
    }
    width: 100%;
   
    font-size: 16px;
    border-bottom: solid 1px rgba(51, 51, 51, 0.3);
    height: 48px;
    padding: 0 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    background: #fff;

    span{
        font-family: "Europa";
        user-select: none;
    }
`;

interface StyledComponentProps {
    isOpen?: boolean;
}

const DropdownMenu: React.FC<DropdownProps> = ({ items, selected, onClick, state = "", altText = "", 
maxHeight = 200,
index = 0, height = 48, borderColor="rgba(51, 51, 51, 0.3)" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownAnimation = useSpring({
        maxHeight: isOpen ? `${Math.min(items?.length * 60, maxHeight)}px` : "0px",
        opacity: isOpen ? 1 : 0,    
        config: { tension: 500, friction: 50 }, // tension과 friction 값 조절
    });

    const handleToggle = (e) => {
        // if(isOpen){
        //     setIsOpen(false)
        // }else{
        //     setIsOpen(true)
        // }
        setIsOpen(v => !v)
        // setIsOpen(!isOpen);
    };

    const dropdownRef = useRef<HTMLDivElement>(null); // DropdownMenu의 ref

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownRef]);

    const handleItemClick = (item: any) => {
        console.log(`선택된 항목: ${item}`);
        const selectItem =
            typeof item === "string" || typeof item === "number" || typeof item === "bigint" ? item : item.dropdownItem;
        onClick(selectItem, state, index, item);
        setIsOpen(false);
    };

    useEffect(() => {
        if(isEmpty(selected)){
            setIsOpen(false);
        }
    }, [selected]);

    // useEffect(() => {
    //     document.addEventListener("click", ()=>{
    //         setIsOpen(false)
    //     })
    // }, []);

    return (
        <DropdownContainer
            ref={dropdownRef}
            className={isOpen ? "on" : ""}>
            <DropdownButton className={"dropdownBtn"} style={{height:height, borderColor:borderColor}} onClick={(e)=>{handleToggle(e)}}>
                <span style={{opacity:selected === "" ? 0.3 : 1}}>{selected === "" ? altText : textTransform().capitalizeFirstLetter(`${selected}`)}</span>
                <DropdownIcon />
            </DropdownButton>
            <AnimatedDropdown
                className={isOpen ? "on" : ""}
                style={{ ...dropdownAnimation, display: isOpen ? "block" : "none" }}>
                <DropdownList isOpen={isOpen}>
                    {items.map((item: any, index) => (
                        <DropdownItem
                            key={index}
                            onClick={() => handleItemClick(item)}
                            style={{
                                top: `${index * 40}px`,
                                height: height,
                            }}
                        >
                           <span> {typeof item === "string" || typeof item === "number" || typeof item === "bigint"
                               // @ts-ignore
                                ? textTransform().capitalizeFirstLetter(`${item}`)
                                : textTransform().capitalizeFirstLetter(String(item.dropdownItem))}
                                </span>
                        </DropdownItem>
                    ))}
                </DropdownList>
            </AnimatedDropdown>
        </DropdownContainer>
    );
};

export { DropdownMenu };
